import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/prospects`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/prospects/${id}?include=user,responsavel,tags`, options)
    .then(response => {
      let prospect = jsona.deserialize(response.data);
      delete prospect.links;
      return prospect;
    });
}

function add(prospect) {

  const payload = jsona.serialize({
    stuff: prospect,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/prospects?include=responsavel,tags`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(prospect) {
  const payload = jsona.serialize({
    stuff: prospect,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/prospects/${prospect.id}?include=responsavel,tags`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/prospects/${id}`, options);
}

function analysis(id) {

  return axios.get(`${url}/analysis/prospects/${id}`)
    .then(response => {
      let analysis = response.data.data;
      return analysis;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  analysis
};

